<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container-xl">
                    <section class="section-hotels-edit-rooms section-hotels-edit-rooms--additional-prices">
                        <div class="hotels-wrap">
                          <HotelsSideMenu />
                            <div class="lds-ring" v-if="!isLoad">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div class="hotels-content" v-if="isLoad">
                                <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                                <div class="hotel-inner-prices">
                                    <form>
                                        <div class="page-title-2">
                                            <h2>Additional Prices</h2>
                                        </div>
                                        <div class="prices-top">
                                            <div class="line-cols">
                                                <div class="form-control-group">
                                                    <span class="form-control-label">Year</span>
                                                    <div class="form-control-wrap">
                                                        <div :class="['select-wrapper', { 'is-active' : selects.year }]"
                                                             @click="openSelect('year')">
                                                            <div class="select-trigger">
                                                                <span class="select-trigger__name">{{
                                                                        year || ''
                                                                    }}</span>
                                                                <span class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg>
                                  </span>
                                                            </div>
                                                            <div class="select-body">
                                                                <div class="select-inner js-scrollbar">
                                                                    <div v-for="(item, index) in data.years"
                                                                         :key="index"
                                                                         :class="['select-option', { 'is-selected' : item === year }]"
                                                                         @click="year = item"><span
                                                                        class="select-option__name">{{ item }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="btn_copy-price">
                                                    <button type="button" @click="copyPopup = year"
                                                            data-popover="Copy rates from the previous year"
                                                            class="btn btn--green btn--sm-squared btn--popover">
                                                        <svg width="1em" height="1em" class="icon icon-copy ">
                                                            <use
                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="meals.length" class="meal-plans bl-sm">
                                            <div class="hotel-subtitle">MEAL PLANS ($)</div>
                                            <div class="section-table section-table--meal">
                                                <div class="section-table__body">
                                                    <div class="section-table__row" v-for="(item, index) in meals"
                                                         :key="index">
                                                        <div class="col col-price-meal">
                                                            <div
                                                                class="section-table__row__number section-table__row__price-for">
                                                                Price for
                                                                {{ item.type }}
                                                            </div>
                                                            <div class="section-table__row__price-details">
                                                                <div class="column-person">
                                                                    <div class="form-control-group--persons__col">
                                                                        <div
                                                                            class="form-control-group--persons__col__info">
                                                                            <svg width="1em" height="1em"
                                                                                 class="icon icon-adult ">
                                                                                <use
                                                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                                                            </svg>
                                                                            <span
                                                                                class="form-control-group--persons__name">Adult</span>
                                                                        </div>
                                                                        <div
                                                                            class="form-control-group form-control-group_currency">
                                                                            <div
                                                                                class="form-control-wrap form-control-wrap_with-label form-control-wrap_with-label_low">
                                                                                <input type="number" placeholder="Title"
                                                                                       class="form-control"
                                                                                       v-model="item.adult"
                                                                                       @change="isEdit = true">
                                                                                <span class="label-inp">$</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="column-person">
                                                                    <div class="form-control-group--persons__col">
                                                                        <div
                                                                            class="form-control-group--persons__col__info">
                                                                            <svg width="1em" height="1em"
                                                                                 class="icon icon-teenager">
                                                                                <use
                                                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                                                            </svg>
                                                                            <span
                                                                                class="form-control-group--persons__name">Teenager:</span>
                                                                        </div>
                                                                        <div
                                                                            class="form-control-group form-control-group_currency">
                                                                            <div
                                                                                class="form-control-wrap form-control-wrap_with-label form-control-wrap_with-label_low">
                                                                                <input type="number" placeholder="Title"
                                                                                       class="form-control"
                                                                                       v-model="item.teenager"
                                                                                       @change="isEdit = true">
                                                                                <span class="label-inp">$</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="column-person">
                                                                    <div class="form-control-group--persons__col">
                                                                        <div
                                                                            class="form-control-group--persons__col__info">
                                                                            <svg width="1em" height="1em"
                                                                                 class="icon icon-child">
                                                                                <use
                                                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                                                            </svg>
                                                                            <span
                                                                                class="form-control-group--persons__name">Child</span>
                                                                        </div>
                                                                        <div
                                                                            class="form-control-group form-control-group_currency">
                                                                            <div
                                                                                class="form-control-wrap form-control-wrap_with-label form-control-wrap_with-label_low">
                                                                                <input type="number" placeholder="Title"
                                                                                       class="form-control"
                                                                                       v-model="item.child"
                                                                                       @change="isEdit = true">
                                                                                <span class="label-inp">$</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="line-additional-fees">
                                            <div class="hotel-subtitle">ADDITIONAL FEES ($)</div>
                                            <div class="line-11" v-for="(item, index) in fees" :key="index">
                                                <div class="form-control-group form-control-group_11">
                                                    <div
                                                        :class="['select-wrapper select-wrapper_10', { 'is-active' : item.open }, { 'is-error' : item.errorType }]"
                                                        @click="item.open = !item.open;item.errorType = false">
                                                        <div class="select-trigger">
                              <span
                                  class="select-trigger__name">{{
                                      data.fees.find(f => f.data === item.type) ? data.fees.find(f => f.data === item.type).name : ''
                                  }}</span>
                                                            <span class="select-trigger__icon">
                                  <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                  </svg>
                                </span>
                                                        </div>
                                                        <div class="select-body">
                                                            <div class="select-inner js-scrollbar">
                                                                <div v-for="(f, idx) in data.fees" :key="idx"
                                                                     :class="['select-option', { 'is-selected' : f.data === item.type }]"
                                                                     @click="item.type = f.data;isEdit = true"><span
                                                                    class="select-option__name">{{ f.name }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-control-group form-control-group_currency-labels">
                                                    <div
                                                        :class="['form-control-wrap form-control-wrap_with-label', { 'is-error' : item.errorPrice }]">
                                                        <input type="number" Placeholder="Title"
                                                               :class="['form-control']"
                                                               @click="item.errorPrice = false" v-model="item.price"/>
                                                        <div class="label-inp label-inp-choice"
                                                             :style="{pointerEvents: 'auto', zIndex: '100', top: '6px'}">
                                                            <label class="ic-info ic-price"
                                                                   @click="item.priceType = 'STATIC';isEdit = true"
                                                                   :style="{cursor: 'pointer'}"> <input type="checkbox"
                                                                                                        @click.prevent.stop
                                                                                                        :checked="item.priceType === 'STATIC' "><span
                                                                class="ic-info__label">$</span></label>
                                                            <label class="ic-info ic-action"
                                                                   v-if="item.type !== 'DRIVERS_ACCOMMODATION'"
                                                                   @click="item.priceType = 'PERCENT';isEdit = true"
                                                                   :style="{cursor: 'pointer'}"> <input type="checkbox"
                                                                                                        @click.prevent.stop
                                                                                                        :checked="item.priceType === 'PERCENT' "><span
                                                                class="ic-info__label">%</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="button" class="btn btn--remove btn_remove-additional"
                                                        @click="$emit('deleteModalHandler', {
                                    entity: 'Fee',
                                    name: 'this',
                                    handler: deleteFees,
                                    id: index
                                })">
                                                    <svg width="1em" height="1em" class="icon icon-close ">
                                                        <use
                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                    </svg>
                                                </button>
                                            </div>

                                            <button type="button"
                                                    class="btn btn--rounded2 btn--green btn_add-additional"
                                                    @click="addFees();isEdit = true"><span>Add Additional Fee</span>
                                            </button>
                                        </div>
                                        <div class="line-festive">
                                            <div class="hotel-subtitle">FESTIVE HOLIDAY SUPPLEMENTS PER PERSON ($)</div>
                                            <div class="line-16" v-for="(item, index) in festive" :key="index"
                                                 :style="{marginBottom: '10px'}">
                                                <div class="form-control-group form-control-group-client">
                                                    <div
                                                        :class="['select-wrapper supplement-type-select', { 'is-active' : item.open }, { 'is-error' : item.errorType }]"
                                                        @click="item.open = !item.open;item.ageOpen = false;item.errorType = false">
                                                        <div class="select-trigger">
                              <span
                                  class="select-trigger__name">{{
                                      data.festive.find(f => f.type === item.type) ? data.festive.find(f => f.type === item.type).name : ''
                                  }}</span>
                                                            <span
                                                                class="select-trigger__icon">
                                  <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                  </svg>
                                </span>
                                                        </div>
                                                        <div class="select-body">
                                                            <div class="select-inner js-scrollbar">
                                                                <div v-for="(f, idx) in data.festive" :key="idx"
                                                                     :class="['select-option', { 'is-selected' : f.type === item.type }]"
                                                                     @click="item.type = f.type;isEdit = true"><span
                                                                    class="select-option__name">{{ f.name }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-control-group form-control-group-client">
                                                    <div
                                                        :class="['select-wrapper supplement-age-select', { 'is-active' : item.ageOpen }, { 'is-error' : item.errorAge }]"
                                                        @click="item.ageOpen = !item.ageOpen;item.open = false;item.errorAge = false">
                                                        <div class="form-control-group-client-icon" v-if="getFestiveAge(item.age)">
                                                            <svg width="1em" height="1em"
                                                                 :class="['icon', getFestiveAge(item.age).icon]">
                                                                <use
                                                                    :xlink:href="`/images/useful/svg/theme/symbol-defs.svg#${getFestiveAge(item.age).icon}`"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="select-trigger">
                                                            <span class="select-trigger__name">{{
                                                                    getFestiveAge(item.age) ? getFestiveAge(item.age).name : ''
                                                                }}</span>
                                                            <span class="select-trigger__icon">
                                                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                                                </svg>
                                                            </span>
                                                        </div>
                                                        <div class="select-body">
                                                            <div class="select-inner js-scrollbar">
                                                                <div v-for="age in data.festiveAges" :key="age.value"
                                                                     :class="['select-option supplement-age-option', { 'is-selected' : age.value === item.age }]"
                                                                     @click="item.age = age.value;isEdit = true">
                                                                    <svg width="1em" height="1em" :class="['icon', age.icon]">
                                                                        <use
                                                                            :xlink:href="`/images/useful/svg/theme/symbol-defs.svg#${age.icon}`"></use>
                                                                    </svg>
                                                                    <span class="select-option__name">{{ age.name }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-control-group form-control-group_currency">
                                                    <div
                                                        :class="['form-control-wrap form-control-wrap_with-label', { 'is-error' : item.errorPrice }]"
                                                        @click="item.errorPrice = false">
                                                        <input type="number" Placeholder="Title" class="form-control"
                                                               v-model="item.price"
                                                               @change="isEdit = true"/>
                                                        <span class="label-inp">$</span>
                                                    </div>
                                                </div>
                                                <div class="form-control-datepicker form-control-datepicker--labeled">
                                                    <div class="form-control-group">
                                                        <span class="form-control-label">From</span>
                                                        <div
                                                            :class="['form-control-wrap', { 'is-error' : item.errorFrom }]"
                                                            @click="item.errorFrom = false">
                                                            <input type="text" Placeholder="Date From"
                                                                   :value="item.dateFrom"
                                                                   @blur="item.dateFrom = $event.target.value"
                                                                   @focus="isEdit = true"
                                                                   class="form-control js-datepicker-single">
                                                            <div class="form-control-icon">
                                                                <svg width="1em" height="1em"
                                                                     class="icon icon-calendar ">
                                                                    <use
                                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="form-control-group">
                                                        <span class="form-control-label">To</span>
                                                        <div
                                                            :class="['form-control-wrap', { 'is-error' : item.errorTo }]"
                                                            @click="item.errorTo = false">
                                                            <input type="text" Placeholder="Date To"
                                                                   :value="item.dateTo"
                                                                   @blur="item.dateTo = $event.target.value"
                                                                   @focus="isEdit = true"
                                                                   class="form-control  js-datepicker-single">
                                                            <div class="form-control-icon">
                                                                <svg width="1em" height="1em"
                                                                     class="icon icon-calendar ">
                                                                    <use
                                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="button" class="btn btn--remove btn_remove-festive"
                                                        @click="$emit('deleteModalHandler', {
								entity: 'Supplement',
								name: 'this',
								handler: deleteFestive,
								id: index
							})">
                                                    <svg width="1em" height="1em" class="icon icon-close ">
                                                        <use
                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                            <div class="line-festive-btns">
                                                <button type="button"
                                                        class="btn btn--rounded2 btn--green btn_add-additional"
                                                        @click="addFestive();isEdit = true"><span>Add Supplement</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="edit-rooms__btn-edit edit-rooms__btn-edit_prices">
                                            <button type="button" class="btn btn--green" @click="updatePopup = true">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="modal-wrapper" v-if="updatePopup">
                            <div class="modal-backdrop"></div>
                            <div class="modal-inner">
                                <div class="edit-popup edit-popup--history">
                                    <div class="edit-popup__header">
                                        <div class="edit-popup__title">
                                            Update History
                                        </div>
                                        <div class="edit-popup__close" @click="updatePopup = false">
                                            <svg width="1em" height="1em" class="icon icon-close ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <form action="javascript:void(0)" class="edit-popup__inner">
                                        <div class="form-control-group"><span
                                            class="form-control-label">Hi {{ user ? user.data.firstName : '' }}, <span> what have you updated?</span> </span>
                                            <div class="form-control-wrap">
                                                <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                                            </div>
                                          <div class="edit-popup__error-text">
                                            <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                                          </div>
                                        </div>
                                        <div class="options-additional__btns">
                                            <button type="button" class="btn btn--silver" @click="updatePopup = false">
                                                <span>Cancel</span>
                                            </button>
                                            <button type="button" class="btn btn--green edit-popup__submit"
                                                    :disabled="descriptionUpdate.length < 6"
                                                    @click="updateHotelsAditionalHandler">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="modal-wrapper" v-if="copyPopup">
                            <div class="modal-backdrop"></div>
                            <div class="modal-inner">
                                <div class="edit-popup edit-popup--copy-md">
                                    <div class="edit-popup__header">
                                        <div class="edit-popup__title">
                                            <div class="edit-popup__title__icon">
                                                <svg width="1em" height="1em" class="icon icon-recover">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                                                </svg>
                                            </div>
                                            <span>Copy from another year</span>
                                        </div>
                                        <div class="edit-popup__close" @click="copyPopup = false">
                                            <svg width="1em" height="1em" class="icon icon-close ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <form action="javascript:void(0)" class="edit-popup__inner">
                                        <div class="edit-popup__form-2">
                                            <div class="form-control-group"><span
                                                class="form-control-label">Choose year</span>
                                                <div :class="['select-wrapper', { 'is-active' : copyPopupOpen }]"
                                                     @click="copyPopupOpen = !copyPopupOpen">
                                                    <div class="select-trigger"><span
                                                        class="select-trigger__name">{{ copyPopupFrom }}</span><span
                                                        class="select-trigger__icon">
										<svg width="1em" height="1em" class="icon icon-chevron ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
										</svg></span></div>
                                                    <div class="select-body">
                                                        <div class="select-inner js-scrollbar">
                                                            <div
                                                                v-for="(y, index) in data.years.filter(y => !(y === copyPopup))"
                                                                :key="index"
                                                                :class="['select-option', { 'is-selected' : copyPopupFrom === y }]"
                                                                @click="copyPopupFrom = y"><span
                                                                class="select-option__name">{{ y }}</span></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="button" class="btn btn--green edit-popup__submit-2"
                                                    @click="copyYearHandler();copyPopup = false">
                                                <svg width="1em" height="1em" class="icon icon-recover">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                                                </svg>
                                                <span>Copy</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

import {
    getHotelsAditionalPrices,
    getHotelsAdvanced,
    copyHotelsAditionalPrices,
    updateHotelsAditionalPrices,
    getHotelAdvanced
} from '@/utilites/api'

import {displayDateToLocalDate, localDateToDisplayDate} from '@/utilites/functions'

import Lightpick from 'lightpick'
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
    data() {
        return {
            id: null,
            updatePopup: false,
            copyPopup: false,
            copyPopupOpen: false,
            descriptionUpdate: '',
            year: new Date().getFullYear(),
            copyHotel: null,
            copyYear: null,
            isEdit: false,
            copyPopupFrom: null,
            isLoad: false,
            meals: [],
            fees: [],
            festive: [],
            selects: {
                year: false,
                hotel: false,
                copyHotel: false,
                copyYear: false,
            },
            data: {
                years: [],
                hotels: [],
                fees: [
                    {
                        id: 4,
                        name: 'Concession Fee - Adult',
                        data: 'CONCESSION_ADULT'
                    },
                    {
                        id: 7,
                        name: 'Concession Teenager',
                        data: 'CONCESSION_TEENAGER'
                    },
                    {
                        id: 5,
                        name: 'Concession Fee - Child',
                        data: 'CONCESSION_CHILD'
                    },
                    {
                        id: 3,
                        name: 'Drivers Accommodation',
                        data: 'DRIVERS_ACCOMMODATION'
                    },
                    {
                        id: 6,
                        name: 'TDL',
                        data: 'TDL'
                    },
                    {
                        id: 1,
                        name: 'WMA Fee - Adult',
                        data: 'WMA_ADULT'
                    },
                    {
                        id: 8,
                        name: 'WMA Teenager',
                        data: 'WMA_TEENAGER'
                    },
                    {
                        id: 2,
                        name: 'WMA Fee - Child',
                        data: 'WMA_CHILD'
                    },
                ],
                meals: [
                    {
                        type: 'BB',
                        "adult": 0,
                        "teenager": 0,
                        "child": 0
                    },
                    {
                        type: 'HB',
                        "adult": 0,
                        "teenager": 0,
                        "child": 0
                    },
                    {
                        type: 'FB',
                        "adult": 0,
                        "teenager": 0,
                        "child": 0
                    },
                    {
                        type: 'AI',
                        "adult": 0,
                        "teenager": 0,
                        "child": 0
                    },
                    {
                        type: 'GP',
                        "adult": 0,
                        "teenager": 0,
                        "child": 0
                    }
                ],
                festive: [
                    {
                        id: 1,
                        type: 'CHRISTMAS_SUPPLEMENT',
                        name: 'Christmas Supplement'
                    },
                    {
                        id: 2,
                        type: 'NEW_YEAR_SUPPLEMENT',
                        name: 'New Year Supplement'
                    },
                    {
                        id: 3,
                        type: 'FESTIVE_SUPPLEMENT',
                        name: 'Festive Supplement'
                    },
                    {
                        id: 4,
                        type: 'EASTER_SUPPLEMENT',
                        name: 'Easter Supplement'
                    },
                ],
                festiveAges: [
                    {
                        value: 'ADULT',
                        name: 'Adult',
                        icon: 'icon-adult'
                    },
                    {
                        value: 'TEENAGER',
                        name: 'Teenager',
                        icon: 'icon-teenager'
                    },
                    {
                        value: 'CHILD',
                        name: 'Child',
                        icon: 'icon-child'
                    }
                ]
            },
            hotelName: ''
        }
    },
    props: ['user'],
    components: {Lightpick, HotelsSideMenu },
    beforeRouteLeave(to, from, next) {
        if (this.isEdit) {
            this.$emit('notLeaveHandler')
        }
        next()
    },
    created() {
        getHotelAdvanced(this.$route.params.id)
            .then(res => {
                this.hotelName = res.names.EN
            })
    },
    mounted() {
        this.updateData()
        const tempYears = [];
        const lastYear = new Date().getFullYear() + 10;
        for (let i = 2021; i < lastYear; i++) {
          tempYears.push(i);
        }
        this.data.years = tempYears;
        window.addEventListener('click', event => {
            if (!event.target.closest('.select-wrapper')) {
                this.selects = {
                    year: false,
                    hotel: false,
                    copyHotel: false,
                    copyYear: false,
                }
                this.fees = this.fees.map(item => ({...item, open: false}))
                this.festive = this.festive.map(item => ({...item, open: false, ageOpen: false}))
            }
        })
    },
    methods: {
        checkErrorsAditional() {
            let error = false
            this.fees = this.fees.map(item => {
                if (!item.type || !item.price) {
                    error = true
                }
                return {
                    ...item,
                    errorType: item.type ? false : true,
                    errorPrice: item.price ? false : true
                }
            })
            this.festive = this.festive.map(item => {
                if (!item.type || !item.age || !item.price || !item.dateFrom || !item.dateTo) {
                    error = true
                }
                return {
                    ...item,
                    errorType: item.type ? false : true,
                    errorAge: item.age ? false : true,
                    errorPrice: item.price ? false : true,
                    errorFrom: item.dateFrom ? false : true,
                    errorTo: item.dateTo ? false : true,
                }
            })
            return error
        },
        checkErrorsCopy() {
            let error = false
            if (!this.copyYear || !this.copyHotel) {
                error = true
            }
            return error
        },
        openSelect(name) {
            this.selects = {
                year: false,
                hotel: false,
                copyHotel: false,
                copyYear: false,
                [name]: !this.selects[name]
            }
        },
        getFestiveAge(age) {
            return this.data.festiveAges.find(item => item.value === age)
        },
        addFees() {
            this.fees = this.fees.concat({
                "type": null,
                "priceType": "STATIC",
                "price": 0,
                open: false
            })
        },
        addFestive() {
            this.festive = this.festive.concat({
                "type": null,
                "age": "ADULT",
                "priceType": "STATIC",
                "price": 0,
                "dateFrom": "",
                "dateTo": "",
                open: false,
                ageOpen: false
            })
            this.updateDatePickers()
        },
        copyYearHandler() {
          copyHotelsAditionalPrices(this.$route.params.id, this.copyPopupFrom, this.year)
            .then(res => {
              this.meals = res.mealPlansPrices
              this.fees = res.additionalFeesPrices.map(item => ({...item, open: false}))
              // this.festive = res.festiveHolidaySupplementsPrices.map(item => ({...item, open: false}))
              this.festive = res.festiveHolidaySupplementsPrices.map(item => ({
                ...item,
                open: false,
                ageOpen: false,
                dateFrom: localDateToDisplayDate(item.dateFrom),
                dateTo: localDateToDisplayDate(item.dateTo)
              }))
              // this.updateDatePickers()
            })
        },
        // copyYearOldHandler() {
        //     const id = this.$route.params.id
        //     getHotelsAditionalPrices(id, this.copyPopupFrom)
        //         .then(res => {
        //             this.meals = res.mealPlansPrices
        //             this.fees = res.additionalFeesPrices.map(item => ({...item, open: false}))
        //             this.festive = res.festiveHolidaySupplementsPrices.map(item => ({
        //                 ...item,
        //                 open: false,
        //                 dateFrom: date(item.dateFrom, 'fromStart'),
        //                 dateTo: date(item.dateTo, 'fromStart')
        //               // dateFrom: `${item.dateFrom.split('.')[0]}.${item.dateFrom.split('.')[1]}.${year}`,
        //               // dateTo: `${item.dateTo.split('.')[0]}.${item.dateTo.split('.')[1]}.${year}`,
        //             }))
        //         })
        //         .catch(() => {
        //             this.id = null
        //             this.meals = []
        //             this.fees = []
        //             this.festive = []
        //         })
        // },
        deleteFestive(id) {
            this.festive = this.festive.filter((_, index) => !(index === id))
            this.updateDatePickers()
            this.isEdit = true
        },
        deleteFees(id) {
            this.fees = this.fees.filter((_, index) => !(index === id))
            this.isEdit = true
        },
        updateData() {
            const id = this.$route.params.id
            this.updateDatePickers()
            // this.meals = this.data.meals
            Promise.allSettled([getHotelsAditionalPrices(id, this.year), getHotelsAdvanced()])
                .then(res => {
                    if (res[0].status === "fulfilled") {
                        this.id = res[0].value.id
                        this.meals = res[0].value.mealPlansPrices
                        this.fees = res[0].value.additionalFeesPrices.map(item => ({...item, open: false}))
                        this.festive = res[0].value.festiveHolidaySupplementsPrices.map(item => ({
                            ...item,
                            open: false,
                            ageOpen: false,
                            dateFrom: localDateToDisplayDate(item.dateFrom),
                            dateTo: localDateToDisplayDate(item.dateTo)
                        }))
                    } else {
                        this.id = null
                        this.meals = []
                        this.fees = []
                        this.festive = []
                    }
                    this.data.hotels = res[1].value
                    this.isLoad = true
                })
                .catch(e => {
                    this.$emit('errored', {text: 'Crosses of periods are detected'})
                })
        },
        updateHotelsAditionalHandler() {
            if (!this.checkErrorsAditional()) {
                const data = {
                    price: {
                        year: this.year,
                        hotelId: +this.$route.params.id,
                        mealPlansPrices: this.meals,
                        additionalFeesPrices: this.fees.map(item => {
                            delete item.open
                            delete item.errorType
                            delete item.errorPrice
                            return {
                                ...item,
                                price: +item.price
                            }
                        }),
                        festiveHolidaySupplementsPrices: this.festive.map(item => {
                            delete item.open
                            delete item.ageOpen
                            delete item.errorType
                            delete item.errorAge
                            delete item.errorPrice
                            delete item.errorFrom
                            delete item.errorTo
                            return {
                                ...item,
                                dateFrom: displayDateToLocalDate(item.dateFrom),
                                dateTo: displayDateToLocalDate(item.dateTo),
                            }
                        }),
                    },
                    history: {
                        hotelId: +this.$route.params.id,
                        userId: this.user.data.id,
                        description: this.descriptionUpdate
                    }
                }
                if (this.id) {
                    data.price.id = this.id
                }
                updateHotelsAditionalPrices(data, this.$route.params.id, this.year)
                    .then(() => {
                        this.isEdit = false
                        this.$emit('confirmed')
                        this.descriptionUpdate = ''
                        this.updatePopup = false
                    })
                    .catch(error => {
                      const message = error.response &&
                        error.response.data &&
                        error.response.data.message

                      this.$emit('errored', {
                        text: message || 'Failed to update additional prices'
                      })
                    })
            } else {
                this.descriptionUpdate = ''
                this.updatePopup = false
            }
        },
        updateDatePickers() {
            document.querySelectorAll('.lightpick').forEach(elem => {
                elem.remove()
            })
            setTimeout(() => {
                document.querySelectorAll('.js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'DD MMM YYYY',
                        onClose: function () {
                            item.blur()
                        },
                        onSelect: function () {
                            item.focus()
                            item.blur()
                        }
                    });
                    item.addEventListener('blur', () => {
                        datePicker.hide()
                    })
                });
            }, 1000)
        },

        waitSaveTiming() {
            const saveFun = () => {
                this.updatePopup = true;
            }
            const waitFun = () => {
                this.waitSaveTiming();
            }
            setTimeout(() => {
                this.$emit('waitSaveHandler', [saveFun, waitFun]);
            }, 10 * 60 * 1000)
        },
    },
    watch: {
        isEdit(val) {
            if (val) this.waitSaveTiming();
        },
        year() {
            this.updateData()
        }
    }
}
</script>

<style scoped>
.line-festive .supplement-type-select .select-trigger__name {
    padding-left: 15px;
}

.section-hotels-edit-rooms--additional-prices {
    max-width: 100%;
}

.section-hotels-edit-rooms--additional-prices .hotel-inner-prices {
    max-width: none;
}

.line-festive .form-control-group-client .supplement-age-select {
    width: 15rem;
}

.supplement-age-option {
    display: flex;
    align-items: center;
    gap: 10px;
}

.supplement-age-option .icon-adult {
    color: #2493d9;
    font-size: 2.3rem;
}

.supplement-age-option .icon-teenager {
    color: #69951e;
    font-size: 1.8rem;
}

.supplement-age-option .icon-child {
    color: #cd67a1;
    font-size: 1.4rem;
}
</style>
